import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader } from '../../Components/Common/DashboardKit';
import 'react-toastify/dist/ReactToastify.css';
import AllDms from "./AllDms";

const DocumentManagementSystem = () => {
    document.title = "DMS | SSW Technologies Inc";

    return (
        <div className="page-content">
            <Container fluid>
                <DashboardPageHeader
                    icon="ri-folder-open-line"
                    eyebrow="Documents"
                    title="Document Management System"
                    subtitle="Browse, search, and manage company documents and engineering change notices."
                    tone="blue"
                    breadcrumb={[
                        { label: "Dashboards", to: "/" },
                        { label: "DMS" },
                    ]}
                />
                <AllDms />
            </Container>
        </div>
    );
};

export default DocumentManagementSystem;
